import loginClient from '../../client/loginClient';
export default class Model {
    public resultData = null;

    public async getData(params: any) {
        const result = await loginClient.getData(params);
        if (result) {
            this.resultData = result;
        }
    }
    public async ajaxLogin(params: any) {
        const result = await loginClient.ajaxLogin(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }
}
